/**
 * Пути до переменных в конечной конфигурации
 * которые не должны попасть в browser
 * @type {String[]}
 */
exports.denied = [
    'port'
];



// WEBPACK FOOTER //
// ./config/env.browser.js